import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { OrderDTO, PaymentDTO, PaymentDTOTransactionTypeEnum, PaymentMethodPaymentMethodIdEnum } from '@lkp/parking-sdk';
import { Subject, takeUntil } from 'rxjs';
import { CheckoutOrderCash } from 'src/app/core/states/orders/orders.action';

@Component({
    selector: 'app-zero-payment',
    templateUrl: './zero-payment.component.html',
    styleUrls: ['./zero-payment.component.scss'],
    standalone: false
})
export class ZeroPaymentComponent {
  readonly onDestroy$ = new Subject<void>();

  constructor(
    readonly dialog: MatDialogRef<ZeroPaymentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { order: OrderDTO, refund: PaymentDTO, maxRefund: number, orderItemId: number },
    readonly store: Store
  ) {
    dialog.disableClose = true;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  closeDialog(success: boolean) {
    this.checkout(false);
  }

  closeAndPrintReceipt() {
    this.checkout(true);
  }

  checkout(printReceipt: boolean) {
    let payment: PaymentDTO = {
      paymentMethod: { paymentMethodId: PaymentMethodPaymentMethodIdEnum.Cash },
      transactionType: PaymentDTOTransactionTypeEnum.Payment,
      amount: 0,
    };

    this.store
    .dispatch(new CheckoutOrderCash(this.data.order.orderId!, payment)).pipe(takeUntil(this.onDestroy$))
    .subscribe(() => {
      if (printReceipt) {
        this.dialog.close({ success: true, receipt: true });
      } else {
        this.dialog.close({ success: true });
      }
    });
  }
}
